import { HttpInterceptorFn } from '@angular/common/http';
import { map } from 'rxjs/operators';

export const fhCamelCasePaginationInterceptor: HttpInterceptorFn = (req, next) => {
  const toCamelCase = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map((v) => toCamelCase(v));
    } else if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce((result, key) => {
        const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
        result[camelKey] = toCamelCase(obj[key]);
        return result;
      }, {} as any);
    }
    return obj;
  };

  return next(req).pipe(
    map((event: any) => {
      if (event?.body?.body?.PaginationResult && typeof event.body.body.PaginationResult === 'object') {
        event.body.body.PaginationResult = toCamelCase(event.body.body.PaginationResult);
      }
      return event;
    })
  );
};
